import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { ServiceGroups, ServiceGroupAmount } from "../interfaces/serviceGroups";

export interface ServiceState {
    availableServices: ServiceGroups,
    selectedServices: ServiceGroupAmount
}

export const initialServiceState: ServiceState = {
    availableServices: {
        activities: [],
        insurances: [],
        transports: []
    },
    selectedServices: {
        activities: [],
        insurances: [],
        transports: []
    }
}

export default {
    namespaced: false,
    state: initialServiceState,
    mutations,
    actions,
    getters
}
